import {parseISO, parse} from 'date-fns';
import type {NormalizedInterval} from 'date-fns';
import type {OfferResult} from '~/openapi';

export function getMealOrderableInterval(meal: OfferResult): NormalizedInterval | null {
	if (!meal.validFrom || !meal.orderableFrom || !meal.orderableTo) {
		return null;
	}

	const validFrom = parseISO(meal.validFrom);

	return {
		start: parse(meal.orderableFrom, 'HH:mm', validFrom),
		end: parse(meal.orderableTo, 'HH:mm', validFrom),
	};
}
